import React from 'react';
import { motion } from 'framer-motion';
import { Eye, Ghost, Heart, Search } from 'lucide-react';
export function ProblemSolution() {
  const problems = [{
    icon: <Ghost className="w-8 h-8" data-id="element-117" />,
    title: 'Mainstream Fatigue',
    desc: 'Drowning in battle royales and sequels? We feel your pain.',
    color: 'bg-brand-pink'
  }, {
    icon: <Eye className="w-8 h-8" data-id="element-118" />,
    title: 'Hidden Gems Buried',
    desc: 'Algorithms hate weird. We love weird. We dig where bots fear to tread.',
    color: 'bg-brand-lime'
  }];
  return <section className="py-24 bg-brand-navy text-brand-offwhite overflow-hidden" data-id="element-119">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-120">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-121">
          {/* Left Column: The Problem */}
          <div className="space-y-12" data-id="element-122">
            <motion.div initial={{
            opacity: 0,
            x: -50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="relative" data-id="element-123">
              <h2 className="text-5xl font-display font-bold mb-6 text-brand-yellow" data-id="element-124">
                The Problem with <br data-id="element-125" />
                <span className="text-white decoration-wavy underline decoration-brand-pink" data-id="element-126">
                  Normal
                </span>
              </h2>
              <p className="text-xl font-body text-gray-300 leading-relaxed" data-id="element-127">
                The gaming world is vast, but most stores only show you the tip
                of the iceberg. The truly extraordinary, experimental, and
                bizarre titles get lost in the noise.
              </p>
            </motion.div>

            <div className="grid gap-6" data-id="element-128">
              {problems.map((item, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: idx * 0.2
            }} className="flex items-start gap-4 bg-white/5 p-6 rounded-none border border-white/10 hover:border-brand-yellow transition-colors" data-id="element-129">
                  <div className={`p-3 ${item.color} text-brand-navy border-2 border-white shadow-[4px_4px_0px_0px_rgba(255,255,255,1)]`} data-id="element-130">
                    {item.icon}
                  </div>
                  <div data-id="element-131">
                    <h3 className="text-xl font-display font-bold mb-2" data-id="element-132">
                      {item.title}
                    </h3>
                    <p className="text-gray-400" data-id="element-133">{item.desc}</p>
                  </div>
                </motion.div>)}
            </div>
          </div>

          {/* Right Column: The Solution */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative" data-id="element-134">
            <div className="absolute -inset-4 bg-brand-purple border-2 border-white rotate-2 opacity-50" data-id="element-135"></div>
            <div className="relative bg-brand-offwhite text-brand-navy p-10 border-4 border-brand-lime shadow-[12px_12px_0px_0px_#BFFF00]" data-id="element-136">
              <div className="absolute -top-6 -right-6 bg-brand-pink text-brand-navy p-4 border-2 border-brand-navy rotate-12 shadow-quirky" data-id="element-137">
                <Heart size={32} fill="currentColor" data-id="element-138" />
              </div>

              <h3 className="text-4xl font-display font-bold mb-6" data-id="element-139">
                Our Extraordinary Solution
              </h3>
              <p className="text-lg font-body mb-6" data-id="element-140">
                We believe in human taste over algorithmic efficiency. Our
                curators play everything—from 5-minute experimental art pieces
                to 100-hour RPGs about sentient vegetables.
              </p>

              <ul className="space-y-4 font-display font-semibold text-xl" data-id="element-141">
                <li className="flex items-center gap-3" data-id="element-142">
                  <Search className="text-brand-purple" data-id="element-143" />
                  Hand-picked discovery
                </li>
                <li className="flex items-center gap-3" data-id="element-144">
                  <Search className="text-brand-purple" data-id="element-145" />
                  No sponsored placements
                </li>
                <li className="flex items-center gap-3" data-id="element-146">
                  <Search className="text-brand-purple" data-id="element-147" />
                  Community of oddballs
                </li>
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}